import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import { mix as color2kMix, darken, lighten, transparentize, parseToRgba, getLuminance, getScale } from 'color2k';
export { darken, lighten, getScale };
export var isValidColor = function isValidColor(color) {
  try {
    parseToRgba(color);
  } catch (_unused) {
    return false;
  }
  return true;
};
export var alpha = function alpha(color, amount) {
  return transparentize(color, 1 - amount);
};
export var mix = function mix(color) {
  return function (baseColor, amount) {
    return color2kMix(baseColor, color, amount);
  };
};
export var isDark = function isDark(color) {
  return getLuminance(color) < 0.43;
};
export var isLight = function isLight(color) {
  return !isDark(color);
};

// Return a contrasting text color for a given background colour

export var contrast = function contrast(color) {
  var darkColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgba(0, 0, 0, 0.8)';
  var lightColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'white';
  return isDark(color) ? lightColor : darkColor;
};

// Make a color a bit lighter or darker,
// depending on whether it is a dark or light color

export var highlight = function highlight(color) {
  var factor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.1;
  return isDark(color) ? lighten(color, factor) : darken(color, factor);
};
export function getPalette(startColor, endColor, length) {
  var scale = getScale(startColor, endColor);
  return Array.from({
    length: length
  }, function (x, i) {
    if (i === 0) return scale(0);
    return scale(i + 1 / (length - 1));
  });
}
export function getColorBlock(color, theme) {
  if (typeof color === 'function') {
    return color(theme);
  }
  if (typeof color !== 'string') {
    throw Error('Color block must be accessed using a string or a function');
  }
  return theme[color] || theme.globals.colorBlocks[color] || color;
}
export function getDimmedTextColor(theme) {
  return alpha(theme.text, theme.textDimStrength);
}
export function getBackgroundShade(theme) {
  return alpha(theme.shade, theme.shadeStrength);
}
export function getSolidBackgroundShade(theme) {
  return color2kMix(theme.background, theme.shade, theme.shadeStrength);
}
export function getColoredBackgroundShade(theme) {
  return alpha(theme.links, Math.max(0.05, +theme.shadeStrength / 2));
}
export function getSolidColoredBackgroundShade(theme) {
  return color2kMix(theme.background, theme.links, Math.max(0.05, +theme.shadeStrength / 2));
}
export function getStrongColoredBackgroundShade(theme) {
  return alpha(theme.links, Math.max(0.15, +theme.shadeStrength));
}
export function getSolidStrongColoredBackgroundShade(theme) {
  return color2kMix(theme.background, theme.links, +theme.shadeStrength);
}
export function getBorderColor(theme) {
  return alpha(theme.shade, theme.lineStrength);
}